    import burger from "./modules/burger";
import FixedElementClearance from "./modules/FixedElementClearance";
import LazyLoad from "vanilla-lazyload";
import MenuToggle from "./modules/MenuToggle";
import SmoothScroll from "smooth-scroll/dist/smooth-scroll";

import blockAsideMenuContent from "./modules/block-asidemenu-content/";
import setWidthSwiperSlide from "./modules/set-width-swiper-slide";
import blockReadMoreFade from "./modules/block-read-more-fade";
import beACustomer from "./modules/be-a-customer";

import "./modules/map";

// Less used modules
//

import DragonModal from "./modules/DragonModal";
// import accordion from "./modules/accordion";
// import DragonTabs from "./modules/DragonTabs";

import slides from "./modules/slides";

export default () => {
    burger();
    blockAsideMenuContent();
    setWidthSwiperSlide();
    blockReadMoreFade();
    beACustomer();

    new LazyLoad({ elements_selector: ".lazy" });

    new SmoothScroll('a[href*="#"]', {
        header: ".main-header-bundle",
        speed: 1500,
        speedAsDuration: true,
        easing: "easeOutQuint",
    });

    new FixedElementClearance({
        element: ".js-get-main-header-height",
        CSSVariableName: "main-header-height",
    });

    new MenuToggle({
        menuToggle: [".js-main-menu-mobile-toggle"],
        menuElement: ".main-menu-mobile",
        menuClose: [".js-close-menu-mobile"],
        activeBodyClass: "mobile-menu-is-open",
        breakpointToHide: 1200,
    });

    // Less used modules
    //
    // accordion();
    // new DragonTabs();

    new DragonModal();
    slides();
};
